var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-apex-charts',{ref:"chart",attrs:{"height":"400","options":_vm.chartOptions,"series":_vm.series},on:{"dataPointSelection":_vm.dataPointSelectionHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }